import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import useReveal from "../components/useReveal";

const faqs = [
  {
    q: "How long does a typical project take?",
    a: "Most projects run between 2–8 weeks of focused build, plus a discovery and strategy phase before that. Larger builds (multi-page, custom platforms, AI systems) can run 2–4 months. We'll give you a clear, honest timeline before any work begins.",
  },
  {
    q: "How do you charge?",
    a: "Fixed-price for clearly scoped projects. Monthly retainers for ongoing growth work (SEO, ads, content, AI ops). We share the price upfront in a written brief — no hidden costs, no surprise invoices.",
  },
  {
    q: "Do you work with small businesses?",
    a: "Yes — some of our favourite work has been with small, thoughtful businesses. What matters more than size is whether you genuinely care about quality and are building something you believe in.",
  },
  {
    q: "What do you need from us to get started?",
    a: "A real conversation, ideally a 30–45 minute call. From there, we shape a strategy and scope document. Once that's approved, we'll need access to relevant accounts (domain, hosting, ads, analytics) and any existing brand assets.",
  },
  {
    q: "Will I own everything you build?",
    a: "Yes. Code, accounts, content, automations — all of it is yours. We document handover clearly, and we don't hold anything hostage. If you ever choose to work with someone else, you keep everything we built.",
  },
  {
    q: "How soon can we start?",
    a: "We typically have a 2–4 week lead time depending on current commitments. If timing is urgent, message us directly on WhatsApp — we'll let you know honestly whether we can fit you in or recommend someone we trust.",
  },
];

export default function About() {
  const [open, setOpen] = useState(null);
  useReveal();

  useEffect(() => {
    document.title = "About — Sutranode";
  }, []);

  return (
    <>
      <section className="section story-section page-with-nav-offset">
        <div className="container">
          <div className="section-heading" data-reveal>
            <div className="s-eyebrow">Our story</div>
          </div>
          <div className="story-inner" data-reveal>
            <div>
              <div className="story-year">2018.</div>
              <div className="story-thread"></div>
            </div>
            <div className="story-right">
              <p>
                It started with voice apps — Alexa skills, Google Assistant actions, and those early
                experiments where nobody quite knew what the mature use case would become. We built
                them, shared what we learned, and discovered something more useful than any single
                tool: that building is step one, but helping it grow is the real work.
              </p>
              <p>
                From there, things widened. We helped brands grow through digital marketing, built AI
                image workflows for e-commerce, and started working with wellness centres, resorts,
                community projects, and lifestyle businesses that needed more than a launch file.
              </p>
              <p>
                That's still what Sutranode is. We sit where strategy, technology, and growth meet. We
                connect the right threads, then stay long enough to make sure they hold under real use.
              </p>
              <Link to="/contact" className="btn-gold">Start a conversation →</Link>
            </div>
          </div>
        </div>
      </section>

      <section className="section faq-section">
        <div className="container">
          <div className="section-heading" data-reveal>
            <div className="s-eyebrow">FAQ</div>
            <h2 className="s-title">Questions we <em>hear often.</em></h2>
          </div>

          <div className="faq-list">
            {faqs.map((f, i) => (
              <div key={i} className={`faq-item ${open === i ? "faq-open" : ""}`} data-reveal>
                <button
                  type="button"
                  className="faq-q"
                  aria-expanded={open === i}
                  onClick={() => setOpen(open === i ? null : i)}
                >
                  <span>{f.q}</span>
                  <span className="faq-icon">
                    <span></span>
                    <span></span>
                  </span>
                </button>
                <div className={`faq-a ${open === i ? "faq-a-open" : ""}`}>
                  <div className="faq-ai">
                    <p>{f.a}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
